import { render, staticRenderFns } from "./InvestmentsTable.vue?vue&type=template&id=6170e929&"
import script from "./InvestmentsTable.vue?vue&type=script&lang=ts&"
export * from "./InvestmentsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6170e929')) {
      api.createRecord('6170e929', component.options)
    } else {
      api.reload('6170e929', component.options)
    }
    module.hot.accept("./InvestmentsTable.vue?vue&type=template&id=6170e929&", function () {
      api.rerender('6170e929', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/organization/profile/transactionalData/InvestmentsTable.vue"
export default component.exports